const angular = require('angular');
const uiRouter = require('angular-ui-router');
const ocLazyLoad = require('oclazyload');
const restangular = require('restangular'); // eslint-disable-line no-unused-vars
const angularToolTip = require('angular-tooltips'); // eslint-disable-line no-unused-vars

// General Modules
const olyCommonModule = require('./olycommon/olycommon.module');
const wowCommonModule = require('./common/common.module');
const shopModule = require('./shop/shop.module');
const analyticsModule = require('./analytics/analytics.module');

// modules that is used acorss the whole site.
const inspirationModule = require('./inspiration/inspiration.module'); // required by shop.
const searchModule = require('./search/search.module');
const authModule = require('./auth/auth.module');
const orderModule = require('./order/order.module');
const fulfilmentModule = require('./fulfilment/fulfilment.module');

// Aplication declaration.
angular.module('wowApp', [
    olyCommonModule,
    wowCommonModule,
    shopModule,
    analyticsModule,
    inspirationModule,
    searchModule,
    authModule,
    fulfilmentModule,
    orderModule,
    uiRouter,
    ocLazyLoad,
    'restangular',
    '720kb.tooltips',
]);

// Application configuration.
require('./configuration');



// WEBPACK FOOTER //
// ./src/wowapp.js